let { isElectron } = require("../deviceChecker");
const diff = require("diff-arrays-of-objects");
const emitter = require("events").EventEmitter;
const { ipcRenderer } = isElectron ? require("electron") : {};

const bleHandler = (() => {
  const bleMsg = {
    Header: [255, 170],
    Footer: [187, 254],
    IntType: [48],
    FloatType: [49],
    StringType: [50],
    WeatherData: [51]
  };

  let initDongle = false;
  let bleScanner = null;
  let discoveredBLEList = [];
  let em = new emitter();

  const changeDongleState = status => {
    if (status === "success") {
      initDongle = true;
    } else {
      initDongle = false;
    }
  };

  const isDongleReady = () => {
    return initDongle;
  };

  const checkDongle = () => {
    const cmd = {
      cmd: "dangleStatus"
    };
    ipcRenderer.send("BLEMessage", cmd);

    var promise = new Promise((resolve, reject) => {
      const checkDongleListener = (event, data) => {
        switch (data.cmd) {
          case "dangleStatus":
            if (data.status === "success") {
              initDongle = true;
              ipcRenderer.removeListener("BLEMessage", checkDongleListener);
              resolve(true);
            } else {
              initDongle = true;
              ipcRenderer.removeListener("BLEMessage", checkDongleListener);
              resolve(false);
            }
            break;
          default:
            break;
        }
      };
      setTimeout(() => {
        initDongle = false;
        resolve(false);
      }, 300);
      ipcRenderer.on("BLEMessage", checkDongleListener);
    });

    return promise;
  };

  const checkConnectedDevice = () => {
    const cmd = {
      cmd: "connectedDevices"
    };
    ipcRenderer.send("BLEMessage", cmd);

    var promise = new Promise((resolve, reject) => {
      const checkConnectedListener = (event, data) => {
        switch (data.cmd) {
          case "connectedDevices":
            resolve(data.device);
            break;
          default:
            break;
        }
      };
      setTimeout(() => {
        ipcRenderer.removeListener("BLEMessage", checkConnectedListener);
        reject("error: timeout");
      }, 2000);
      ipcRenderer.on("BLEMessage", checkConnectedListener);
    });

    return promise;
  };
  /**
   * Tell python to start scan
   * @param {int} time scan period in microseconds
   */
  const startBleScan = time => {
    console.log("ipcRenderer", ipcRenderer);
    clearInterval(bleScanner);
    bleScanner = setInterval(() => {
      ipcRenderer.send("BLEMessage", {
        cmd: "scan"
      });
    }, time);
  };
  /**
   * Tell python to stop scan
   */
  const stopScan = () => {
    clearInterval(bleScanner);
    bleScanner = null;
  };

  const getScanedDevices = () => {
    return discoveredBLEList;
  };

  const connectTo = macAddress => {
    const connectParameter = {
      cmd: "connect",
      mac: macAddress
    };
    ipcRenderer.send("BLEMessage", connectParameter);

    var promise = new Promise((resolve, reject) => {
      const connectLinster = (event, data) => {
        switch (data.cmd) {
          case "connect":
            // console.log('connectStatus: ', data)
            ipcRenderer.removeListener("BLEMessage", connectLinster);
            resolve(data);
            break;
          default:
            break;
        }
      };
      ipcRenderer.on("BLEMessage", connectLinster);
    });

    return promise;
  };

  const disconnectFrom = macAddress => {
    const connectParameter = {
      cmd: "disconnect",
      mac: macAddress
    };
    ipcRenderer.send("BLEMessage", connectParameter);

    var promise = new Promise((resolve, reject) => {
      const disconnectListener = (event, data) => {
        switch (data.cmd) {
          case "disconnect":
            // console.log('connectStatus: ', data)
            ipcRenderer.removeListener("BLEMessage", disconnectListener);
            resolve(data);
            break;
          case "disconnected":
            ipcRenderer.removeListener("BLEMessage", disconnectListener);
            resolve(data);
            break;
          default:
            break;
        }
      };
      ipcRenderer.on("BLEMessage", disconnectListener);
    });

    return promise;
  };

  const checkScanResult = options => {
    // const sortOptions = options.sort((a, b) => (a.name > b.name ? 1 : -1));
    // console.log('this iteration result: ', discoverdBLEList, sortOptions);

    const compareResult = diff(discoveredBLEList, options, "mac");

    // console.log(compareResult)

    if (compareResult.added.length) {
      em.emit("newBLE", compareResult.added);
    }
    if (compareResult.removed.length) {
      em.emit("removedBLE", compareResult.removed);
    }
    discoveredBLEList = options;
  };

  const parseRecieveData = data => {
    const { mac } = data;
    const dataMsg = data.data;
    let reciveData;
    // console.log(dataMsg, typeof dataMsg[0]);
    if (dataMsg[0] === 255 && dataMsg[1] === 170 && dataMsg[dataMsg.length - 2] === 187 && dataMsg[dataMsg.length - 1] === 254) {
      // A communication with end byte
      switch (dataMsg[6]) {
        case 48:
          // Int
          // dataMsg.slice(6, dataMsg.length - 2)
          reciveData = parseInt(
            dataMsg
              .slice(7, dataMsg.length - 2)
              .map(el => String.fromCharCode(el))
              .join("")
          );
          console.log("Int: ", reciveData);
          return reciveData;
          break;
        case 49:
          // Float
          reciveData = parseFloat(
            dataMsg
              .slice(7, dataMsg.length - 2)
              .map(el => String.fromCharCode(el))
              .join("")
          );
          console.log("Float: ", reciveData);
          break;
        case 50:
          // String
          reciveData = dataMsg
            .slice(7, dataMsg.length - 2)
            .map(el => String.fromCharCode(el))
            .join("");
          if (reciveData === "getClass") {
            em.emit("needSendClass");
          }
          console.log("String: ", reciveData);
          break;
        case 51:
          // weather
          console.log("weather: ", dataMsg.slice(6));
          // sendWeatherData(mac, [dataMsg[2], dataMsg[3], dataMsg[4], dataMsg[5]], converStringToChar(weatherDataCenter.getWeatherData(dataMsg[7], dataMsg[8])));
          break;
        default:
          break;
      }
    }
    return reciveData;
  };

  const sendDataToDevice = (datatype, data, macAddress) => {
    const macLast4 = macAddress
      .split(":")
      .splice(-4)
      .map(el => parseInt(el, 16));
    const convertData = data
      .toString()
      .split("")
      .map(el => el.charCodeAt(0));
    //a.split('').map(el => el.charCodeAt(0))
    // a = 30; a.toString()
    const sendParameter = {
      cmd: "sendData",
      mac: macAddress,
      data: bleMsg.Header.concat(macLast4)
        .concat(bleMsg[datatype])
        .concat(convertData)
        .concat(bleMsg.Footer)
    };
    console.log(sendParameter);

    ipcRenderer.send("BLEMessage", sendParameter);
  };

  const sendDataToDeviceAndWaitForRes = (datatype, data, macAddress, timeout) => {
    const macLast4 = macAddress
      .split(":")
      .splice(-4)
      .map(el => parseInt(el, 16));
    const convertData = data
      .toString()
      .split("")
      .map(el => el.charCodeAt(0));
    //a.split('').map(el => el.charCodeAt(0))
    // a = 30; a.toString()
    const sendParameter = {
      cmd: "sendData",
      mac: macAddress,
      data: bleMsg.Header.concat(macLast4)
        .concat(bleMsg[datatype])
        .concat(convertData)
        .concat(bleMsg.Footer)
    };
    // console.log(sendParameter);

    ipcRenderer.send("BLEMessage", sendParameter);

    var promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(-1);
      }, timeout);
      const respLinstener = (event, data) => {
        switch (data.cmd) {
          case "receive":
            // console.log('connectStatus: ', data)
            ipcRenderer.removeListener("BLEMessage", respLinstener);
            const reciveData = parseRecieveData(data);
            if (typeof reciveData !== "undefined") {
              resolve(reciveData);
            } else {
              resolve("-100");
            }
            break;
          default:
            break;
        }
      };
      ipcRenderer.on("BLEMessage", respLinstener);
    });

    return promise;
  };

  const sendWeatherData = (mac, macText, data) => {
    const sendParameter = {
      cmd: 'sendWeather',
      mac,
      data: [255, 170].concat(macText).concat([51]).concat(data).concat([187, 254]),
    };
    console.log('send weather data', sendParameter)

    ipcRenderer.send('BLEMessage', sendParameter);
  };

  const uploadFW = (mac, { hexPath: path }) => {
    console.log("path", path);
    const sendParameter = {
      cmd: "uploadFW",
      board: "E310",
      mac,
      path
    };
    ipcRenderer.send("BLEMessage", sendParameter);
    var promise = new Promise((resolve, reject) => {
      const respLinstener = (event, data) => {
        console.log("respLinstener", data);
        switch (data.cmd) {
          case "uploadFW":
            if (data.status === "uploading") {
              // console.log(data)
              const emitData = {
                percentage: data.data,
                mac: data.mac
              };
              em.emit("percentage", emitData);
            } else if (data.status === "success") {
              ipcRenderer.removeListener("BLEMessage", respLinstener);
              resolve("Upload Success");
              console.log("build sucess");
            } else if (data.status === "fail") {
              reject("Some error!");
            }
            // console.log('connectStatus: ', data)
            break;
          default:
            break;
        }
      };
      ipcRenderer.on("BLEMessage", respLinstener);
    });

    return promise;
  };
  ipcRenderer.on("WeatherRequest", (event, data)=>{
    if(data.cmd ===  "receive"){
      em.emit("pyBLEweatherRequest", data);
    }
  })

  ipcRenderer.on("BLEMessage", (event, data) => {
    console.log(data);
    switch (data.cmd) {
      case "scan":
        checkScanResult(data.device);
        break;
      case "initDangle":
        changeDongleState(data.status);
        break;
      case "reconnect":
        em.emit("reconnect", data);
        break;

      case "disconnect":
        //disconnect 是使用者斷線
        em.emit("disconnect", data);
        break;

      case "disconnected":
        em.emit("disconnected", data);
        break;
      case "receive":
        let result = parseData(data);
        em.emit("receiveFromPy", parseSerialData(result));
        break;
      default:
        break;
    }
  });

  return {
    on: em.on.bind(em),
    isDongleReady,
    checkDongle,
    checkConnectedDevice,
    startBleScan,
    stopScan,
    getScanedDevices,
    connectTo,
    disconnectFrom,
    sendDataToDevice,
    sendWeatherData,
    eventNames: em.eventNames.bind(em),
    removeAllListeners: em.removeAllListeners.bind(em),
    removeListener: em.removeListener.bind(em),
    sendDataToDeviceAndWaitForRes,
    uploadFW
  };
})();

const parseData = data => {
  let dataMsg = data.data;
  if (dataMsg[0] === 255 && dataMsg[1] === 170 && dataMsg[dataMsg.length - 2] === 187 && dataMsg[dataMsg.length - 1] === 254) {
    // A communication with end byte
    switch (dataMsg[6]) {
      case 48:
        // Int
        console.log("Int: ", dataMsg.slice(6));
        break;
      case 49:
        // Float
        console.log("Float: ", dataMsg.slice(6));
        break;
      case 50:
        // String
        console.log("String: ", dataMsg.slice(6));
        break;
      case 51:
        // weather
        // sendWeatherData(mac, [dataMsg[2], dataMsg[3], dataMsg[4], dataMsg[5]], converStringToChar(weatherDataCenter.getWeatherData(dataMsg[7], dataMsg[8])));
        break;
      default:
        break;
    }
  }
  return dataMsg;
};

const parseSerialData = data => {
  // const text = data.map(e => String.fromCharCode(String(e))).join('');
  const text = data.reduce((str, charIndex) => {
    const newStr = str + String.fromCharCode(charIndex);
    return newStr;
  }, "");

  return text;
};

ipcRenderer.on("python", (event, data) => {
  // console.log(data);
});

export default bleHandler;
